import { c as _c } from "react/compiler-runtime";
import { CopyableContent } from "@/src/components/copyable-content";
import { ValerieCardColSpan, ValerieCardField } from "@/src/components/valerie-card";
import { useComparison } from "@/src/context/comparison-text";
import { getDisplayValue, compareStrings, FieldType } from "@/src/lib/utils/string-utils";
interface ComparisonFieldProps {
  label: string;
  value: string;
  secondaryValue: string;
  type?: FieldType;
  compareAgainstTitle?: string;
  colSpan?: ValerieCardColSpan;
  startsRow?: boolean;
}
export function ComparisonField(t0) {
  const $ = _c(23);
  const {
    label,
    value,
    secondaryValue,
    type: t1,
    compareAgainstTitle: t2,
    colSpan,
    startsRow
  } = t0;
  const type = t1 === undefined ? "text" : t1;
  let compareAgainstTitle = t2 === undefined ? "EMR" : t2;
  const context = useComparison();
  if (context?.comparisonLabel) {
    compareAgainstTitle = context.comparisonLabel;
  }
  let t3;
  if ($[0] !== type || $[1] !== value) {
    t3 = getDisplayValue(value, type);
    $[0] = type;
    $[1] = value;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const formattedValue = t3;
  let t4;
  if ($[3] !== secondaryValue || $[4] !== type) {
    t4 = getDisplayValue(secondaryValue, type);
    $[3] = secondaryValue;
    $[4] = type;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const formattedSecondaryValue = t4;
  let t5;
  if ($[6] !== secondaryValue || $[7] !== type || $[8] !== value) {
    t5 = compareStrings(value, secondaryValue, type);
    $[6] = secondaryValue;
    $[7] = type;
    $[8] = value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const hasConflict = !t5;
  const t6 = `${hasConflict ? "bg-warn/20" : "text-foreground"}`;
  let t7;
  if ($[10] !== formattedValue || $[11] !== t6) {
    t7 = <CopyableContent text={formattedValue} textClassName={t6} />;
    $[10] = formattedValue;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== compareAgainstTitle || $[14] !== formattedSecondaryValue || $[15] !== hasConflict) {
    t8 = hasConflict && <div className="text-xs text-muted-foreground mt-1"><span className="text-warn dark:text-warn">{compareAgainstTitle}:{" "}<CopyableContent text={formattedSecondaryValue} textClassName="text-warn dark:text-warn" /></span></div>;
    $[13] = compareAgainstTitle;
    $[14] = formattedSecondaryValue;
    $[15] = hasConflict;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== colSpan || $[18] !== label || $[19] !== startsRow || $[20] !== t7 || $[21] !== t8) {
    t9 = <ValerieCardField label={label} colSpan={colSpan} startsRow={startsRow}>{t7}{t8}</ValerieCardField>;
    $[17] = colSpan;
    $[18] = label;
    $[19] = startsRow;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}